var _defs, _g, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _g3, _g4, _path, _rect13, _path2, _path3, _path4, _rect14, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect15, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#daf4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c8bf8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7055",
    "data-name": "Groupe 7055",
    transform: "translate(-207 -178)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_569",
    "data-name": "Rectangle 569",
    transform: "translate(207 178)",
    stroke: "#707070",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 149,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7053",
    "data-name": "Groupe 7053",
    transform: "translate(192.806 -31.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9807",
    "data-name": "Trac\\xE9 9807",
    d: "M155.322,272.722c-1.4-1-5.391-1.916-9.652-1.894-3.562.018-10.444,1.935-10.444,1.935-2.511-2.242-11.49-4.22-17.468.048-1.6-4.474-8-6.277-11.668-3.283,1.283-6.3-3.554-13.188-9.887-14.071S83.378,259.878,82.927,266.3c.256-3.818-4.625-6.867-7.9-4.936a11.24,11.24,0,0,0-11.583-9.707,11.221,11.221,0,0,0-9.887,11.415,7.771,7.771,0,0,0-9.714-3.141,6.7,6.7,0,0,0-1,.579,7.379,7.379,0,0,0-1.931,2.015c-4.244-1.253-11.323-.172-13.262,5.79a8.836,8.836,0,0,0-.418,3.43,7.53,7.53,0,0,0,.216,1.294,3.247,3.247,0,0,0-2.715,1.685,5.223,5.223,0,0,0-.341,3.782,7.939,7.939,0,0,0,11.382,5.126,10.955,10.955,0,0,0,8.157,5.16,15.761,15.761,0,0,0,9.6-2.155c-1.656,4.628,2.972,8.267,4.888,9.114,6.035,2.664,14.72,1,18.989-5.515a6.2,6.2,0,0,0,5.735,2.3,5.265,5.265,0,0,0,4.181-3.276A11.862,11.862,0,0,0,97.438,292.9c4.768-.48,7.387-2.668,8.791-5.277a6.66,6.66,0,0,0,4.335.476c4.834-1.477,4.577-5.3,3.991-6.24a3.311,3.311,0,0,0,1.751.213,4.94,4.94,0,0,0,2.946-1.774c.139.051.279.1.425.154a16.794,16.794,0,0,0,7.087.949,19.523,19.523,0,0,0,9.329-3.646c2.737-.15,5.269-.3,7.791-.634q.956-.121,1.916-.286a43.725,43.725,0,0,0,7.729-2.026c.454-.161.912-.33,1.374-.513C156.073,273.839,156.088,273.264,155.322,272.722Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9808",
    "data-name": "Trac\\xE9 9808",
    d: "M302.723,307.83c-.462.183-.92.352-1.374.513a43.73,43.73,0,0,1-7.729,2.026q-.962.165-1.916.286c-2.521.33-5.053.483-7.791.634a19.523,19.523,0,0,1-9.329,3.646,16.794,16.794,0,0,1-7.087-.949c-.147-.051-.286-.1-.425-.154a4.94,4.94,0,0,1-2.946,1.774,7.15,7.15,0,0,1,.3-3.617l.022-.066a4.829,4.829,0,0,1,1.147-1.817,4.588,4.588,0,0,1,4.042-.975,8.58,8.58,0,0,1,3.76,2.026,10.635,10.635,0,0,1,10.37-3.316,8.427,8.427,0,0,0,1.891.374,6.419,6.419,0,0,0,1.715-.312c4.467-1.213,10.653-2.371,15.765-1.649C303.906,306.8,303.892,307.372,302.723,307.83Z",
    transform: "translate(-147.818 -33.533)",
    fill: "#cce1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9809",
    "data-name": "Trac\\xE9 9809",
    d: "M116.61,304.471a3.532,3.532,0,0,0-1.894.59,8.789,8.789,0,0,0-6.776-.333,5.5,5.5,0,0,1,5.995-3.566c-2.4-1.389-6.178-1.422-8.241.425a11.785,11.785,0,0,0-1.506,1.993s-2.393-3.4-5.867-3.914a7.575,7.575,0,0,0-7.032,3.221c-1.8-5.914-9.676-7.874-14.5-3.467,3.162-1.1,6.589-.927,7.418,2.342a5.4,5.4,0,0,0-7.366,3.254,2.278,2.278,0,0,0-3.521-1.371,2.179,2.179,0,0,0-.594,2.2c-5.028-3.543-12.241-1.625-14.417.948.933-3.091,3.995-4.407,7.465-4.257-3.8-2.987-9.368-3.851-13.377-1.194a4.966,4.966,0,0,0-1.8-6.992,5.583,5.583,0,0,0-7.065,2.206,6.646,6.646,0,0,0,.941,7.607,16.611,16.611,0,0,0-5.919.9c1.691,1.1,1.915,3.7,1.915,3.7a9.572,9.572,0,0,0-7.4-3.453s1.146-1.032,3.756-.763a8.713,8.713,0,0,0-2.293-3.637c-1.821-1.8-4.486-1.936-7.087-1.861a3.247,3.247,0,0,0-2.715,1.685,5.224,5.224,0,0,0-.341,3.782,7.939,7.939,0,0,0,11.382,5.126,10.955,10.955,0,0,0,8.157,5.16,15.762,15.762,0,0,0,9.6-2.155c-1.656,4.628,2.972,8.267,4.888,9.114,6.035,2.664,14.72,1,18.989-5.515a6.2,6.2,0,0,0,5.735,2.3,5.265,5.265,0,0,0,4.181-3.276,11.862,11.862,0,0,0,10.118,3.639c4.768-.48,7.387-2.668,8.791-5.277a6.661,6.661,0,0,0,4.335.476c4.834-1.477,4.577-5.3,3.991-6.24a3.311,3.311,0,0,0,1.751.213,4.94,4.94,0,0,0,2.946-1.774c.139.051.279.1.425.154a16.794,16.794,0,0,0,7.087.949C122.9,305.695,119.128,304.313,116.61,304.471Z",
    transform: "translate(0 -26.014)",
    fill: "#cce1f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7052",
    "data-name": "Groupe 7052",
    transform: "translate(228.231 174.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7051",
    "data-name": "Groupe 7051",
    transform: "translate(10.769 8.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7050",
    "data-name": "Groupe 7050",
    transform: "translate(12.374)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 20.692,
    height: 45.345,
    transform: "translate(5.383 98.655)",
    fill: "#eeb23b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 28.926,
    height: 32.573,
    transform: "translate(1.266 68.665)",
    fill: "#eeb23b"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 28.926,
    height: 5.022,
    transform: "translate(1.266 96.216)",
    fill: "#e6a21b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 16.891,
    height: 21.668,
    transform: "translate(7.284 74.548)",
    fill: "#e6a21b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 20.692,
    height: 4.305,
    transform: "translate(5.383 69.668)",
    fill: "#e6a21b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 1.469,
    height: 3.804,
    transform: "translate(7.336 69.919)",
    fill: "#753806"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 1.47,
    height: 3.804,
    transform: "translate(10.399 69.919)",
    fill: "#753806"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_579",
    "data-name": "Rectangle 579",
    width: 1.469,
    height: 3.804,
    transform: "translate(13.463 69.919)",
    fill: "#753806"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_580",
    "data-name": "Rectangle 580",
    width: 1.469,
    height: 3.804,
    transform: "translate(16.526 69.919)",
    fill: "#753806"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_581",
    "data-name": "Rectangle 581",
    width: 1.47,
    height: 3.804,
    transform: "translate(19.589 69.919)",
    fill: "#753806"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 1.47,
    height: 3.804,
    transform: "translate(22.652 69.919)",
    fill: "#753806"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_583",
    "data-name": "Rectangle 583",
    width: 28.926,
    height: 2.373,
    transform: "translate(1.266 66.509)",
    fill: "#cc8900"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7048",
    "data-name": "Groupe 7048",
    transform: "translate(8.053 75.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9758",
    "data-name": "Trac\\xE9 9758",
    d: "M50.3,118.527c-.608.074-1.216.133-1.823.18s-1.216.11-1.823.152c-1.216.084-2.431.147-3.646.2s-2.431.089-3.646.109-2.431.046-3.646.027l-.753-.012v-.74c0-1.566.1-3.133.191-4.7.08-1.567.2-3.133.255-4.7s.056-3.133.034-4.7-.118-3.133-.189-4.7l-.02-.435.482-.027c2.43-.138,4.86-.268,7.291-.311l3.646-.074c1.215-.023,2.43-.06,3.646-.052l.891.005.008.894c.016,1.567-.014,3.133-.043,4.7s-.081,3.133-.146,4.7-.157,3.133-.252,4.7c-.043.783-.094,1.566-.165,2.35s-.124,1.566-.209,2.35l-.008.075Zm-.093-.178c-.081-.751-.139-1.5-.2-2.256-.071-.783-.122-1.566-.165-2.35-.095-1.567-.2-3.133-.252-4.7s-.114-3.133-.146-4.7-.059-3.133-.044-4.7l.9.9c-1.216.007-2.431-.03-3.646-.052l-3.646-.075c-2.431-.043-4.861-.172-7.291-.311l.462-.463c-.071,1.567-.161,3.133-.189,4.7s-.028,3.133.034,4.7.175,3.133.255,4.7c.1,1.566.187,3.133.191,4.7l-.752-.752c1.215-.019,2.431.013,3.646.028s2.43.065,3.646.108,2.43.116,3.646.2c.607.043,1.215.1,1.823.152C49.051,118.224,49.628,118.279,50.205,118.349Z",
    transform: "translate(-34.963 -98.744)",
    fill: "#ae7500"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7049",
    "data-name": "Groupe 7049",
    transform: "translate(9.304 77.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9759",
    "data-name": "Trac\\xE9 9759",
    d: "M49.836,108.872s-.007.169-.018.483a4,4,0,0,1-.053.579,6.106,6.106,0,0,1-.127.78,7.7,7.7,0,0,1-.7,2.031,7.028,7.028,0,0,1-1.757,2.221,6.032,6.032,0,0,1-3.125,1.321,7.926,7.926,0,0,1-.94.03,6.242,6.242,0,0,1-.915-.126,6.031,6.031,0,0,1-1.813-.674,7.654,7.654,0,0,1-2.789-2.762,8.139,8.139,0,0,1-.962-5.953,7.64,7.64,0,0,1,.755-1.938,7.108,7.108,0,0,1,2.9-2.828,6.283,6.283,0,0,1,3.751-.653,6.2,6.2,0,0,1,3.148,1.375,7.152,7.152,0,0,1,1.753,2.235,7.682,7.682,0,0,1,.7,2.033,6.148,6.148,0,0,1,.125.78,3.943,3.943,0,0,1,.051.581C49.83,108.7,49.836,108.872,49.836,108.872Zm-.084,0s-.01-.165-.029-.478a3.958,3.958,0,0,0-.065-.571,4.424,4.424,0,0,0-.169-.757,6.767,6.767,0,0,0-2.724-3.738,6.429,6.429,0,0,0-2.791-1.066,5.994,5.994,0,0,0-3.288.557,6.4,6.4,0,0,0-2.654,2.424,7.634,7.634,0,0,0-1.123,3.64,7.973,7.973,0,0,0,.186,1.934,7.144,7.144,0,0,0,.729,1.807,5.977,5.977,0,0,0,2.767,2.489,5.635,5.635,0,0,0,1.694.465,6.148,6.148,0,0,0,.87.043,7.411,7.411,0,0,0,.807-.067,6.7,6.7,0,0,0,2.815-1.121,6.848,6.848,0,0,0,2.719-3.753,4.431,4.431,0,0,0,.166-.757,3.775,3.775,0,0,0,.063-.572C49.742,109.036,49.751,108.87,49.751,108.87Z",
    transform: "translate(-36.445 -101.324)",
    fill: "#ae7500"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9760",
    "data-name": "Trac\\xE9 9760",
    d: "M48.882,109.076a5.387,5.387,0,1,1-5.385-5.518A5.451,5.451,0,0,1,48.882,109.076Z",
    transform: "translate(-27.401 -23.694)",
    fill: "#b8d0d1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    "data-name": "Rectangle 584",
    width: 15.316,
    height: 15.785,
    transform: "translate(8.071 102.386)",
    fill: "#e6a21b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9761",
    "data-name": "Trac\\xE9 9761",
    d: "M26.925,85.146,33.73,72.808l-.788-1.722H51.1v1.722l4.751,12.338Z",
    transform: "translate(-25.659 -18.637)",
    fill: "#5f8e8d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9762",
    "data-name": "Trac\\xE9 9762",
    d: "M32.965,71.22a12.686,12.686,0,0,1-.14,2.44c-.446,1.34-1.4,2.29-2.041,3.548-1.3,2.54-2.561,5.174-3.709,7.766,1.363-.594,2.835-.106,4.194.03a27.536,27.536,0,0,0,7.456-.317c-.464-1.148-3.04-.69-3.179-2.075-.082-.818,1.075-1.2,1.613-1.73a5.773,5.773,0,0,0,1.868-3.34c.241-1.894.2-1.9,1.619-3.388.718-.754,1.149-1.847,1.879-2.475-2.6-.133-7.219-1.28-9.56-.172Z",
    transform: "translate(-25.682 -18.628)",
    fill: "#3b7572"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9763",
    "data-name": "Trac\\xE9 9763",
    d: "M34.541,71.75c3.522-1.356,9.52,2.584,12.068,4.623,2.84,2.272,3.688,5.238,4.282,8.557,2.147.112,4.206-.512,6.333-.122-1.934-.8-3.6-6.567-4.525-8.709a10.328,10.328,0,0,1-.879-2.194c-.1-.588.276-1.408.182-1.866-.286-1.39-1.58-1.006-2.808-1-2.944,0-5.7.285-8.628.144-2.254-.109-4.921-.419-6.991.12.292-.108.1-.329.263-.55Z",
    transform: "translate(-26.694 -18.584)",
    fill: "#3b7572"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    width: 16.284,
    height: 13.345,
    transform: "translate(8.071 39.104)",
    fill: "#eeb23b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9764",
    "data-name": "Trac\\xE9 9764",
    d: "M52,70.8a1.066,1.066,0,0,1-1.056,1.076H34.629A1.066,1.066,0,0,1,33.574,70.8h0a1.066,1.066,0,0,1,1.055-1.077H50.946A1.066,1.066,0,0,1,52,70.8Z",
    transform: "translate(-26.694 -18.425)",
    fill: "#5f8e8d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9765",
    "data-name": "Trac\\xE9 9765",
    d: "M36.76,125.055c0-1.338-.306-2.422-.682-2.422s-.682,1.084-.683,2.422Z",
    transform: "translate(-26.978 -26.665)",
    fill: "#753806"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9766",
    "data-name": "Trac\\xE9 9766",
    d: "M39.763,125.055c0-1.338-.306-2.422-.682-2.422s-.682,1.084-.682,2.422Z",
    transform: "translate(-27.446 -26.665)",
    fill: "#753806"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9767",
    "data-name": "Trac\\xE9 9767",
    d: "M42.766,125.055c0-1.338-.306-2.422-.683-2.422s-.681,1.084-.681,2.422Z",
    transform: "translate(-27.913 -26.665)",
    fill: "#753806"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9768",
    "data-name": "Trac\\xE9 9768",
    d: "M45.769,125.055c0-1.338-.306-2.422-.682-2.422s-.682,1.084-.682,2.422Z",
    transform: "translate(-28.381 -26.665)",
    fill: "#753806"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9769",
    "data-name": "Trac\\xE9 9769",
    d: "M48.552,125.055c0-1.338-.306-2.422-.682-2.422s-.681,1.084-.681,2.422Z",
    transform: "translate(-28.815 -26.665)",
    fill: "#753806"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9770",
    "data-name": "Trac\\xE9 9770",
    d: "M51.555,125.055c0-1.338-.3-2.422-.682-2.422s-.681,1.084-.681,2.422Z",
    transform: "translate(-29.282 -26.665)",
    fill: "#753806"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9771",
    "data-name": "Trac\\xE9 9771",
    d: "M45.033,110.157a.495.495,0,1,1-.489-.573A.536.536,0,0,1,45.033,110.157Z",
    transform: "translate(-28.327 -24.632)",
    fill: "#004946"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9772",
    "data-name": "Trac\\xE9 9772",
    d: "M40.993,106.933c-.038-.042,0-.142.085-.223h0c.085-.082.185-.113.224-.071l4.334,4.731c.038.041,0,.141-.085.223h0c-.086.08-.186.113-.224.071Z",
    transform: "translate(-27.847 -24.171)",
    fill: "#004946"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9773",
    "data-name": "Trac\\xE9 9773",
    d: "M49.919,105.143c.066-.048.188.01.274.131h0c.086.121.1.258.037.307l-7.414,5.486c-.065.047-.187-.011-.274-.132h0c-.085-.121-.1-.258-.037-.306Z",
    transform: "translate(-28.079 -23.938)",
    fill: "#004946"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9774",
    "data-name": "Trac\\xE9 9774",
    d: "M53.4,88.355c.53,3.46-.892,7.663-1.99,10.871a86.668,86.668,0,0,1-5.475,13.63c-1.589,2.89-4.275,8.084-7.159,9.939.98,0,16.792.184,18.32,0-.122-4.159.653-30.729.527-33.255-.128-2.589-3.344-1.079-4.75-1.292Z",
    transform: "translate(-27.505 -21.271)",
    fill: "#e6a21b",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9775",
    "data-name": "Trac\\xE9 9775",
    d: "M44.276,87.984c2.239.208,3.848,4.345,4.73,5.961a46.757,46.757,0,0,1,4.561,10.084,45.631,45.631,0,0,1,1.266,12.856,22.818,22.818,0,0,1-.295,3.417c-.079.425-.465,1.351-.217,1.666.514.653,3.6.373,4.4.332a72.188,72.188,0,0,1-.516-9.3c-.117-3.768-.269-7.614-.106-11.384.115-2.648.1-5.318.3-7.961.117-1.588.653-3.421.429-5-4.937.09-10.162-1.412-15.072-.574.163-.167.177-.426.309-.626Z",
    transform: "translate(-28.28 -21.184)",
    fill: "#e6a21b",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9776",
    "data-name": "Trac\\xE9 9776",
    d: "M29.922,90.8c-1.392.109-1.563,3.307-1.19,4.358.291.821,1.258,1.431,1.309,2.351s-.789,1.666-1.083,2.487c-.58,1.62.017,3.071.263,4.689.31,2.03.534,4.113.81,6.134.3,2.184.745,4.367,1.157,6.521.368,1.929,1.237,3.081,2.064,4.754a23.3,23.3,0,0,0-5.572.221c-.265-10.324.978-21.018-.271-31.207a7.185,7.185,0,0,1,2.267.265c-.254.24-.486.129-.881.144Z",
    transform: "translate(-25.734 -21.707)",
    fill: "#ffc654"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9777",
    "data-name": "Trac\\xE9 9777",
    d: "M40.776,55.393c-1.13.875-1.15,2.363-1.267,3.654-.123,1.364-.751,2.5-.875,3.852a9.032,9.032,0,0,0,.58,4.518,10.724,10.724,0,0,1-4.469-.283c.319-3.359,1.3-8.4.274-11.712,1.866-.133,4.35-.393,5.9-.317Z",
    transform: "translate(-26.876 -16.146)",
    fill: "#ffc654"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9778",
    "data-name": "Trac\\xE9 9778",
    d: "M38.638,66.673a.77.77,0,0,1-.762.777h0a.77.77,0,0,1-.763-.777V58.561a.771.771,0,0,1,.763-.778h0a.771.771,0,0,1,.762.778Z",
    transform: "translate(-27.245 -16.565)",
    fill: "#753806"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9779",
    "data-name": "Trac\\xE9 9779",
    d: "M42.263,66.673a.769.769,0,0,1-.762.777h0a.77.77,0,0,1-.763-.777V58.561a.771.771,0,0,1,.763-.778h0a.77.77,0,0,1,.762.778Z",
    transform: "translate(-27.81 -16.565)",
    fill: "#753806"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9780",
    "data-name": "Trac\\xE9 9780",
    d: "M45.617,66.673a.77.77,0,0,1-.762.777h0a.77.77,0,0,1-.762-.777V58.561a.77.77,0,0,1,.762-.778h0a.771.771,0,0,1,.762.778Z",
    transform: "translate(-28.332 -16.565)",
    fill: "#753806"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9781",
    "data-name": "Trac\\xE9 9781",
    d: "M48.685,66.673a.77.77,0,0,1-.762.777h0a.77.77,0,0,1-.762-.777V58.561a.77.77,0,0,1,.762-.778h0a.771.771,0,0,1,.762.778Z",
    transform: "translate(-28.81 -16.565)",
    fill: "#753806"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9782",
    "data-name": "Trac\\xE9 9782",
    d: "M51.475,66.673a.77.77,0,0,1-.763.777h0a.769.769,0,0,1-.762-.777V58.561a.77.77,0,0,1,.762-.778h0a.77.77,0,0,1,.763.778Z",
    transform: "translate(-29.245 -16.565)",
    fill: "#753806"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9783",
    "data-name": "Trac\\xE9 9783",
    d: "M38.824,143.553c0,.573-.342,1.038-.763,1.038h0c-.421,0-.762-.465-.762-1.038V132.72c0-.574.341-1.038.762-1.038h0c.421,0,.763.464.763,1.038Z",
    transform: "translate(-27.274 -28.074)",
    fill: "#cc8900"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9784",
    "data-name": "Trac\\xE9 9784",
    d: "M42.449,143.553c0,.573-.341,1.038-.762,1.038h0c-.42,0-.762-.465-.762-1.038V132.72c0-.574.342-1.038.762-1.038h0c.421,0,.762.464.762,1.038Z",
    transform: "translate(-27.839 -28.074)",
    fill: "#cc8900"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9785",
    "data-name": "Trac\\xE9 9785",
    d: "M48.307,143.808c0,.573-.341,1.038-.762,1.038h0c-.421,0-.762-.465-.762-1.038V132.976c0-.575.341-1.039.762-1.039h0c.421,0,.762.464.762,1.039Z",
    transform: "translate(-28.751 -28.114)",
    fill: "#cc8900"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9786",
    "data-name": "Trac\\xE9 9786",
    d: "M51.933,143.808c0,.573-.341,1.038-.762,1.038h0c-.42,0-.762-.465-.762-1.038V132.976c0-.575.342-1.039.762-1.039h0c.421,0,.762.464.762,1.039Z",
    transform: "translate(-29.316 -28.114)",
    fill: "#cc8900"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586",
    "data-name": "Rectangle 586",
    width: 15.317,
    height: 15.785,
    transform: "translate(8.493 123.48)",
    fill: "#e6a21b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9787",
    "data-name": "Trac\\xE9 9787",
    d: "M39.324,168.539c0,.572-.341,1.038-.763,1.038h0c-.42,0-.762-.465-.762-1.038V157.706c0-.575.342-1.039.762-1.039h0c.422,0,.763.464.763,1.039Z",
    transform: "translate(-27.352 -31.965)",
    fill: "#cc8900"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9788",
    "data-name": "Trac\\xE9 9788",
    d: "M42.95,168.539c0,.572-.341,1.038-.762,1.038h0c-.421,0-.763-.465-.763-1.038V157.706c0-.575.342-1.039.763-1.039h0c.421,0,.762.464.762,1.039Z",
    transform: "translate(-27.917 -31.965)",
    fill: "#cc8900"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9789",
    "data-name": "Trac\\xE9 9789",
    d: "M48.807,168.794c0,.572-.341,1.038-.762,1.038h0c-.421,0-.762-.465-.762-1.038V157.962c0-.575.341-1.04.762-1.04h0c.421,0,.762.465.762,1.04Z",
    transform: "translate(-28.829 -32.005)",
    fill: "#cc8900"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9790",
    "data-name": "Trac\\xE9 9790",
    d: "M52.434,168.794c0,.572-.342,1.038-.763,1.038h0c-.421,0-.762-.465-.762-1.038V157.962c0-.575.341-1.04.762-1.04h0c.421,0,.763.465.763,1.04Z",
    transform: "translate(-29.394 -32.005)",
    fill: "#cc8900"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9791",
    "data-name": "Trac\\xE9 9791",
    d: "M27.187,128.509c-.025.1-.242.019-.122.259,4.1,1.526,3.067,4.241,3.814,8.02.579-1.59-.42-5.477.842-6.679.687-.656,4.063-.941,5-1.027-3.159.108-6.424-.576-9.546-.42-.157-.124.073-.113.017-.3Z",
    transform: "translate(-25.675 -27.557)",
    fill: "#ae7500"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9792",
    "data-name": "Trac\\xE9 9792",
    d: "M59.7,128.768c-2.07.834-3.858,4.356-4.081,6.558a38.85,38.85,0,0,0-.282-4.549c-.248-1.877-.963-1.409-2.1-2.263,2.26-.193,5.089.4,7.18-.292a5.7,5.7,0,0,1-1.138-.027Z",
    transform: "translate(-29.757 -27.531)",
    fill: "#ae7500"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9793",
    "data-name": "Trac\\xE9 9793",
    d: "M52.356,73.514c-.185.964.079,2.169-.42,3.012-.55-.128-.6-1.014-1.125-1.015-.277,0-.969.841-1.4.988-1.022.344-2.749-.115-3.846-.116-2.317,0-4.681.736-6.959.287a48.5,48.5,0,0,0,7.969.575c.888,0,2.767-.392,3.569-.011,1.023.487.494,1.35,1.9.6.111.792.627.648.877.988a7.317,7.317,0,0,1,.8,1.435c.49,1.125,1.4,2.407,1.283,3.713-1.307.095-3.066.757-4.242.594,2.5-.111,5.032.973,7.592,1.011-3.935-3.483-3.792-9.7-6.425-13.639Z",
    transform: "translate(-27.478 -18.769)",
    fill: "#3b7572",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9794",
    "data-name": "Trac\\xE9 9794",
    d: "M34.985,48.065H51.269l-3.257-6.444L43.148,9.473l-.141-.512-.364,1.157-3.86,29.373Z",
    transform: "translate(-26.914 -8.961)",
    fill: "#3b7572"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9795",
    "data-name": "Trac\\xE9 9795",
    d: "M46.039,16.659c0,.731-.85,1.325-1.9,1.325s-1.9-.594-1.9-1.325.849-1.326,1.9-1.326S46.039,15.927,46.039,16.659Z",
    transform: "translate(-28.044 -9.954)",
    fill: "#3b7572"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9796",
    "data-name": "Trac\\xE9 9796",
    d: "M43.05,10.33a5.963,5.963,0,0,0-.3,3.1c.057.541.248,1.06.274,1.6.046.952-.327,1.111-.472,1.985-.133.8.336,1.156.523,1.872.36,1.388-.295,2.942-.348,4.35-.241,6.372-.83,12.74-1.056,19.1a6.833,6.833,0,0,0-.008,2.217c.364.644,2.579.972,2.356,2.172-.141.764-1.651.874-2.193.974-1.866.348-4.621-.392-6.265.614-.079-1.006,1.335-2.62,1.784-3.547a35.864,35.864,0,0,0,2.068-4.311c.905-2.77.652-5.9.913-8.787.3-3.323.724-6.747,1.217-10.033a35.715,35.715,0,0,0,.539-5.369c-.6-.072-.371-.412-.279-.856.03-.148.449-.154.514-.339.07-.2-.048-.511-.008-.724a11.086,11.086,0,0,0,.212-4.663Z",
    transform: "translate(-27.004 -9.074)",
    fill: "#5f8e8d"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9797",
    "data-name": "Trac\\xE9 9797",
    d: "M52,54.395a.64.64,0,0,1-.634.646H34.207a.64.64,0,0,1-.633-.646h0a.64.64,0,0,1,.633-.647h17.16a.64.64,0,0,1,.634.647Z",
    transform: "translate(-26.694 -15.936)",
    fill: "#005e57"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9798",
    "data-name": "Trac\\xE9 9798",
    d: "M45,17.911c-1.339.084.08,1.472.106,2.152.018.509-.318.9-.239,1.4.061.388.453.971.552,1.418a16.37,16.37,0,0,1,.11,3.818,44.828,44.828,0,0,0,.633,4.58c.221,2.231.312,4.5.422,6.753.043.894-.043,1.795,0,2.69A15.344,15.344,0,0,1,46.9,43.31c-.019.137.148.406.205.516-.968.066-2.285.022-3.066.022.682-.064,3.485.066,3.794.643.207.388-.338.582-.274.864.115.507.133.263.4.621.165.226.523.068.749.458.02.035-.183.743-.2.843,1.325-.019,2.516.786,3.776,1.117-.815,0-2.362-3.724-2.71-4.653a26.756,26.756,0,0,1-1.082-5.789c-.583-4.391-1.331-8.81-1.9-13.176-.3-2.308-.783-4.6-1.069-6.848-.145.062-.454.015-.6.079a1.658,1.658,0,0,1-.016-.42Z",
    transform: "translate(-28.324 -10.305)",
    fill: "#3b7572",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9799",
    "data-name": "Trac\\xE9 9799",
    d: "M43.665,18.751a100.1,100.1,0,0,1-1.184,16.385,18.341,18.341,0,0,1-1.558,5.593c-.428.81-1.586,2.5-2.193.956-.9,2.031-3.126,4.213-3.282,6.43A55.623,55.623,0,0,0,50.2,47.36c-3.766-3.247-3.632-9.667-4.529-14.3-.6-3.1-.652-6.157-.951-9.279-.163-1.7.133-4.49-.924-5.9-.23-.306-.164-.477-.659-.428Z",
    transform: "translate(-26.986 -10.283)",
    fill: "#3b7572",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9800",
    "data-name": "Trac\\xE9 9800",
    d: "M44.385,22.469c-.126,2.049.466,4.02.216,6.128a24.5,24.5,0,0,0-.437,4.724A21.389,21.389,0,0,0,44.944,36c.477,2.331.307,6-.878,8.1a9,9,0,0,1-2.632,2.825,10.54,10.54,0,0,1-2.719,1.581,14.341,14.341,0,0,0,6.725.44,21.737,21.737,0,0,1,5.455.083c-1.587-1.159-2.169-3.982-2.924-5.711-1.118-2.559-1.165-5.508-1.661-8.232-.809-4.435-.44-9.758-1.821-13.8Z",
    transform: "translate(-27.495 -10.881)",
    fill: "#3b7572",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9801",
    "data-name": "Trac\\xE9 9801",
    d: "M42.989,16.624c-.1-.139.013-.317-.3-.2-.364.8.18.86.306,1.49a6.415,6.415,0,0,1-.112,1.748c-.138,1.56-.411,3.083-.637,4.631-.453,3.107-1.184,6.361-.924,9.545.984-1.646,1.129-4.694,1.431-6.645.244-1.581.311-3.177.549-4.759a13.528,13.528,0,0,0,.53-3.552c-.089-.621-.43-.97-.533-1.615-.072-.447.75-1.273-.523-.968Z",
    transform: "translate(-27.892 -10.094)",
    fill: "#8bc6c3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9802",
    "data-name": "Trac\\xE9 9802",
    d: "M52.413,55.153c-.386,2.984-.363,6.217-1.581,9.043a29.421,29.421,0,0,1-2.031,3.31c-.788,1.34.137,1.193.629,2.31.485,1.1-.031,2.82-.181,3.951a15.628,15.628,0,0,1-1.19,4.01c-.539,1.272-1.759,3.288-1.858,4.589a58.5,58.5,0,0,0,6.107.123c2.058-.1,4.39-.556,6.407.006-1.209-.124-1.721-2.4-2.155-3.32-.49-1.04-1.164-1.981-1.586-3.059-.659-1.684-2.189-4.493-1.823-6.329.084-.425.594-.611.529-1.182-.072-.624-.52-.452-.824-.887-.551-.788-.133-1.61-.127-2.585a55.606,55.606,0,0,1,.024-7.2,7.385,7.385,0,0,0,.068-2.973,1.816,1.816,0,0,0-.407-.017Z",
    transform: "translate(-28.66 -16.121)",
    fill: "#3b7572",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9803",
    "data-name": "Trac\\xE9 9803",
    d: "M56.778,86.834a.907.907,0,0,1-.894.918H26.319a.906.906,0,0,1-.894-.918h0a.906.906,0,0,1,.894-.919H55.884a.907.907,0,0,1,.894.919Z",
    transform: "translate(-25.425 -20.946)",
    fill: "#00443e"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9804",
    "data-name": "Trac\\xE9 9804",
    d: "M33.876,55.449c-.015,2.831.024,5.739-.1,8.583a13.149,13.149,0,0,1-.217,3.039c-.272.733-1.191.862-.844,1.83.113.312.659.463.717.777s-.385.927-.508,1.268a24.056,24.056,0,0,1-1.29,2.691,51.368,51.368,0,0,1-3.276,5.486,12.626,12.626,0,0,1-1.541,2.247c1.424-.6,3.174-.2,4.705-.2-1.653.04-1.638-1.412-1.029-2.449a37.344,37.344,0,0,0,1.879-4.654c.4-.951.8-2.705,1.528-3.449.279-.286.842-.209,1.008-.534.4-.783-.29-.56-.61-.861-.465-.436-.6-.007-.319-.842.168-.507.525-.182.43-.9a13.151,13.151,0,0,1-.427-1.27c-.051-.526,0-1.082,0-1.611V58.36c0-.534.009-1.074-.012-1.6a1.709,1.709,0,0,0-.516-.017Z",
    transform: "translate(-25.642 -16.201)",
    fill: "#fff",
    opacity: 0.4
  })))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9805",
    "data-name": "Trac\\xE9 9805",
    d: "M31.652,154.034c.285.055.736-.136,1.161-.106.521.037.832.506,1.266.535.937.064,1.45-1.037,2.533-.73.5.142.545.6,1.161.617.682.023.625-.313,1.158-.527a1.506,1.506,0,0,1,1.269-.134c.468.208.5.9.951,1.067,1.014.376,1.562-1.243,2.527-1.255.911-.013,1.195,1.2,2.2.828.911-.333.673-1.5,1.927-.717.576.36.273.806,1.055.745.41-.032.49-.512,1.15-.4.487.081.6.407,1.166.4a5.275,5.275,0,0,0,1.13-.317c-1.133.085-2.113-.712-3.11-.611-.189.019-.361.491-.575.485-.463-.014-.285-.306-.528-.38-.479-.146-.952-.525-1.565-.343-.566.169-.6.685-1.264.641-.443-.03-.765-.57-1.264-.635-1.187-.155-1.673,1.232-2.831,1.036-.341-1.438-1.463-.991-2.425-.588-1.324.555-1.127-.091-2.425-.369-.7-.149-.659.166-1.182.345-.873.3-.567.079-1.263-.113-.917-.254-2.387-.626-2.222.818,0-.165,0-.332,0-.5Z",
    transform: "translate(-3.25 -22.454)",
    fill: "#e6a21b"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9806",
    "data-name": "Trac\\xE9 9806",
    d: "M32.179,150.9c.285.055.736-.136,1.161-.106.521.037.832.507,1.266.536.937.063,1.45-1.038,2.533-.731.5.142.545.6,1.161.617.682.024.624-.313,1.158-.527a1.506,1.506,0,0,1,1.269-.134c.468.208.5.9.951,1.067,1.014.376,1.562-1.242,2.527-1.255.911-.013,1.195,1.2,2.2.829.911-.333.673-1.5,1.927-.718.576.36.273.806,1.055.745.41-.031.49-.512,1.15-.4.487.081.6.407,1.166.4a5.275,5.275,0,0,0,1.13-.317c-1.133.085-2.113-.712-3.111-.611-.188.019-.36.491-.575.485-.463-.014-.285-.306-.528-.381-.479-.146-.951-.525-1.564-.343-.566.169-.6.686-1.264.641-.443-.03-.765-.57-1.264-.635-1.187-.155-1.673,1.232-2.831,1.036-.341-1.438-1.463-.991-2.425-.588-1.324.555-1.127-.091-2.425-.368-.7-.149-.659.165-1.182.344-.873.3-.566.08-1.263-.113-.917-.254-2.387-.626-2.222.818,0-.165,0-.331,0-.5Z",
    transform: "translate(-3.332 -21.966)",
    fill: "#e6a21b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.c44909e56e549f7ae8f9e68a3fdbe180.svg";
export { ForwardRef as ReactComponent };